import { render, staticRenderFns } from "./ChangeLogin.vue?vue&type=template&id=353353e3"
import script from "./ChangeLogin.vue?vue&type=script&lang=js"
export * from "./ChangeLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports